import { Injectable } from '@angular/core';
import clone from 'clone';

@Injectable({providedIn: 'root'})
export class ClonerService {
  deepClone(value): any {
    return clone(value);
  }
}
